import {
  GET_ALL_BOOKING,
  CREATE_NEW_BOOKING,
  CHANGE_EDIT_BOOKING,
  VALUE_PUP_BOOKING,
  EMPTY_PUP_BOOKING,
} from '../../constant';

const allBookingData = [
  {
    id: 1,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
  {
    id: 2,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
  {
    id: 3,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
  {
    id: 4,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
  {
    id: 5,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
  {
    id: 6,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
  {
    id: 7,
    data: '14 April 11:00',
    patient: 'HNXXXXXX415',
    gender: 'M',
    age: 40,
    remark: 'AML',
    status: 'Outstanding',
    ward: 'A3',
    bedNo: 21,
    specialty: 'Text here',
    diagnosis: 'Text here',
  },
];
const booking = (state = allBookingData, action) => {
  const { type, data } = action;
  switch (type) {
    case GET_ALL_BOOKING:
      return state;
    case CREATE_NEW_BOOKING:
      return [data, ...state];
    case CHANGE_EDIT_BOOKING:
      return state.map((item) => {
        return item.id === data.id ? data : item;
      });
    default:
      return state;
  }
};

const initPupBooking = {
  data: '',
  patient: '',
  gender: 'M',
  age: '',
  remark: '',
  status: '',
  ward: '',
  bedNo: '',
  specialty: '',
  diagnosis: '',
};
const pupBooking = (state = initPupBooking, action) => {
  const { type, data } = action;
  switch (type) {
    case VALUE_PUP_BOOKING:
      return data;
    case EMPTY_PUP_BOOKING:
      return initPupBooking;
    default:
      return state;
  }
};

export { booking, pupBooking };
